(function () {
    'use strict';

    var module = angular.module('imApp');

    module.component('case', {
        templateUrl: 'views/components/views/case/case.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'modalService', 'caseService', 'translateService', 'logisticService', 'rememberService', 'utilityService', function ($stateParams, stateService, modalService, caseService, translateService, logisticService, rememberService, utilityService) {

            // #region VARIABLES & DEFINITIONS

            var vm = this;
            var caseKeyno = $stateParams.case_keyno;

            var variableNames = {
                report_id: '',
                printergroup_id: '',
                printerlocation_id: '',
                printer_id: ''
            };

            var translations = {
                case_show_title: 'Varsel',
                case_show_ok_label: 'OK'
            };

            vm.model = {
                setting: {},
                gridReady: false,
                lockedSave: false,
                selectListReports: [],
                selectListPrinterGroups: [],
                selectListPrinterLocations: [],
                selectListPrinters: []
            };

            vm.grid = {
                dataTask: {
                    rememberId: '',
                    loadSetupId: null,
                    loadData: {},
                    addRow: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    },
                    removeRow: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    },
                    saveData: {
                        method: null,
                        parameters: null,
                        autoSave: false,
                        confirm: false
                    }
                },
                translations: [],
                config: {
                    editColumns: [
                        //{ key: 'test_column' }
                        //'prod_name', 'stock_stockvalue', 'is_selected', { key: 'test_column', lookup: 1900, relations: [{ key: 'stockplace_name', value: 'item_id' }], optionfunc: true }, 'reg_date'
                    ],
                    toolbar: {
                        hidden: false,
                        pdfExport: true,
                        excelExport: true,
                        filter: true,
                        columnVisibility: true,
                        headers: true,
                        edit: false,
                        lock: false,
                        add: false,
                        delete: false,
                        save: false,
                        wrapping: true,
                        layouts: true,
                        buttons: [
                            //{ name: 'cancel', text: '', func: function () { console.log('this is a test with default icon'); } },
                            //{ name: 'test', text: '', func: function () { testItems(); } },
                            //{ name: 'customSave', text: '', func: function () { saveItems(); }, icon: 'save' },
                            //{ name: 'customAddBefore', text: '', func: function () { addItemBefore(); }, icon: 'insert-up' },
                            //{ name: 'customAddAfter', text: '', func: function () { addItemAfter(); }, icon: 'insert-down' },
                            //{ name: 'customDelete', text: '', func: function () { deleteItem(); }, icon: 'delete' }
                        ]
                    },
                    fixedHeader: true,
                    keepSortOnAdd: false,
                    keepSortOnCheckbox: false,
                    keepSortOnIsSelected: false,
                    rowClick: false,
                    specialFunc: {
                        newTab: true,
                        buttons: [
                            //{ name: 'test', text: '', func: function (data) { testItems(data); }, icon: 'far-star' }
                        ]
                    },
                    css: {
                        altColor: true,
                        textWrapping: false
                    },
                    onDataSourceChanges: function (e) {
                        //console.log('onDataSourceChanges');
                        //console.dir(e);
                    },
                    onDataChanged: function (changed, e) {
                        //console.log('onDataChanged');
                        //console.dir(e);
                    }
                },
                kendo: {
                    height: null,
                    aggregate: true,
                    pager: false,
                    selectable: false, //'multiple, row'
                    //persistSelection: false,
                    filterable: false
                },
                optionfunc: function (data) { optionfunc(data.data); },
                gridfunc: null
            };

            var optionfunc = function (data) { };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            var getReports = function () {
                logisticService.listReports('case').then(function (result) {
                    angular.copy(result, vm.model.selectListReports);
                });
            };

            var getPrinterGroups = function () {
                logisticService.listPrinterGroups().then(function (result) {
                    angular.copy(result, vm.model.selectListPrinterGroups);
                });
            };

            var getPrinterLocations = function () {
                logisticService.listPrinterLocations().then(function (result) {
                    angular.copy(result, vm.model.selectListPrinterLocations);
                });
            };

            var getPrinters = function (printergroup_id, printerlocation_id) {
                logisticService.listAllPrinters(parseInt(printergroup_id), parseInt(printerlocation_id)).then(function (result) {
                    angular.copy(result, vm.model.selectListPrinters);
                });
            };

            caseService.getCase({ case_keyno: caseKeyno }).then(function (result) {

                getPrinterGroups();
                getPrinterLocations();
                getReports();

            	angular.copy(result[0], vm.model.setting);
                vm.grid.dataTask.rememberId = 'w_case_stockbatches_grid';
		        
		        vm.grid.dataTask.loadData = {
                    method: 2559,
                    parameters: vm.model.setting
		        };
		        
                vm.model.gridReady = true;

                getPrinters(vm.model.setting.printergroup_id, vm.model.setting.printerlocation_id);
            });

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.handleFieldChanged = function (value, id) {
                if (id.startsWith('vm.') !== true) return;

                var parts = id.split('.');

                switch (parts[parts.length - 1]) {
                    case 'printergroup_id':
                        vm.model.setting.printergroup_id = value;

                        if (value > '0') {
                            getPrinters(value, vm.model.setting.printerlocation_id);
                        }

                        if (utilityService.validateParmsValue(vm.model.setting.printergroup_id) !== true) return;

                        rememberFunc('printergroup_id');

                        break;

                    case 'printerlocation_id':
                        vm.model.setting.printerlocation_id = value;
                        getPrinters(vm.model.setting.printergroup_id, value);

                        if (utilityService.validateParmsValue(vm.model.setting.printerlocation_id) !== true) return;

                        rememberFunc('printerlocation_id');
                        break;

                    case 'printer_id':
                        vm.model.setting.printer_id = value;

                        if (utilityService.validateParmsValue(vm.model.setting.printer_id) !== true) return;

                        rememberFunc('printer_id');
                        break;

                    case 'report_id':
                        vm.model.setting.report_id = value;

                        if (utilityService.validateParmsValue(vm.model.setting.report_id) !== true) return;

                        rememberFunc('report_id');
                        break;
                    default:
                        utilityService.setValueToVariable(vm, parts, value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            var rememberFunc = function (id) {
                angular.forEach(variableNames, function (_, key) {
                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                var variableValue = null;

                switch (id) {
                    case 'report_id':
                        if (utilityService.validateParmsValue(vm.model.setting.report_id) !== true) return;
                        variableValue = vm.model.setting.report_id;
                        break;

                    case 'printergroup_id':
                        if (utilityService.validateParmsValue(vm.model.setting.printergroup_id) !== true) return;
                        variableValue = vm.model.setting.printergroup_id;
                        break;
                    case 'printerlocation_id':
                        if (utilityService.validateParmsValue(vm.model.setting.printerlocation_id) !== true) return;
                        variableValue = vm.model.setting.printerlocation_id;
                        break;
                    case 'printer_id':
                        if (utilityService.validateParmsValue(vm.model.setting.printer_id) !== true) return;
                        variableValue = vm.model.setting.printer_id;
                        break;

                    default:
                        break;
                }

                rememberService.remember(variableNames[id], variableValue);
            };

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                caseService.saveObj(vm.model.setting).then(function (response) {
                    if (response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.case_show_title,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.case_show_ok_label,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();		
                    }
                });
            };

		    translateService.translateBatch(translations).then(function (data) {
			    angular.forEach(translations, function (_, key) {
				    if (angular.isDefined(data[key])) {
					    translations[key] = data[key];
				    }
			    });
		    });

		    // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL
        }]
    });
})();
